import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import AnchorsEnum from '../enumerators/anchors.enum'

export default class AnchorsComponent {
    constructor() {
        this.anchorsReveal()
        this.anchorsSlider()
        this.onClick()
    }

    async anchorsSlider() {
        if ($(AnchorsEnum.ELEMENT).length > 0) {
            await Swiper.create(AnchorsEnum.ELEMENT, {
                slidesPerView: 'auto',
                pagination: false,
                navigation: {
                    nextEl: '.anchors-slider-button-next',
                    prevEl: '.anchors-slider-button-prev',
                    disabledClass: 'anchors-slider-button-disabled',
                    hiddenClass: 'anchors-slider-button-hidden',
                },
                mousewheel: {
                    forceToAxis: true,
                },
                a11y: {
                    prevSlideMessage:
                        IRISCollectionTheme.translate.slider.prevSlideMessage ?? 'Slide précédente',
                    nextSlideMessage:
                        IRISCollectionTheme.translate.slider.nextSlideMessage ?? 'Slider suivante',
                    firstSlideMessage:
                        IRISCollectionTheme.translate.slider.firstSlideMessage ??
                        'Vous êtes sur la première slide',
                    lastSlideMessage:
                        IRISCollectionTheme.translate.slider.lastSlideMessage ??
                        'Vous avez atteint la dernière slide',
                    paginationBulletMessage:
                        IRISCollectionTheme.translate.slider.paginationBulletMessage ??
                        'Aller sur la slide {{index}}',
                    slideLabelMessage:
                        IRISCollectionTheme.translate.slider.slideLabelMessage ??
                        'Slide {{index}} sur {{slidesLength}}',
                },
                preventClicks: false,
                grabCursor: true,
                loop: false,
                watchSlidesProgress: true,
                on: {
                    init: (swiper) => {
                        if (swiper.isLocked) {
                            $(swiper.el).addClass('anchors-slider-lock')
                        } else {
                            document.addEventListener('active.hc.scrollspy', (e) => {
                                const index = $(e.detail.item).parent().index()
                                swiper.slideTo(index)
                            })
                        }
                    },
                },
            })
        }
    }

    anchorsReveal() {
        if ($(AnchorsEnum.TRIGGER_REVEAL).length > 0) {
            // Position sticky anchors
            const triggerPosition = $('#main').offset().top - 200
            $(window).scroll(() => {
                const top = $(window).scrollTop()
                if (top > triggerPosition) {
                    if (!$(AnchorsEnum.TRIGGER_REVEAL).hasClass('active')) {
                        $(AnchorsEnum.TRIGGER_REVEAL).addClass('active')
                    }
                } else {
                    $(AnchorsEnum.TRIGGER_REVEAL).removeClass('active')
                }
            })
        }
    }

    onClick() {
        $(AnchorsEnum.TRIGGER).on('click', () => {
            const element = $(this).attr('href')
            $(element).attr('tabindex', '-1')
            $(element).addClass('not-focus-style')
            $(element).focus()
        })
    }
}
